import { AddRounded, ChevronRight } from "@mui/icons-material";
import { Box, Card, CardHeader, Theme, Typography } from "@mui/material";
import { Variant } from "@mui/material/styles/createTypography";
import { columns } from ".";
import route, { NavLinkComponent } from "../../Router";
import NavLink, { NavButton } from "../../components/NavLink";
import AccentPaper from "../../components/Paper";
import DataTable, { BaseDataTable, ColumnData, NoDataText, Renderer } from "../../components/data/DataTable";
import car from "../../icons/car.png";
import CachedStore from "../../models/CachedStore";
import { useCachedStore, useIsMobile, useTenantId } from "../../models/Hooks";
import { EntryPass } from "../../models/Types";
import { entryPassParse } from "./EntryPassForm";
import { buildEntryPassListItem } from "./EntryPassList";

const entryPassActiveStore = CachedStore.Configure<EntryPass>('EntryPassActive', `EntryPassActive?query=${JSON.stringify({ Count: 4, LazyLoad: true })}`, 10 * 60);
function MobileWidget() {
    const [data] = useCachedStore(entryPassActiveStore, undefined, true);

    const btn = <AccentPaper component={NavLinkComponent}
        route={[['page', 'entrypass'], ['id', 'new']]}
        sx={{ display: 'flex', flexDirection: 'column', gap: 2, justifyContent: 'space-between', textDecoration: 'none', py: .75, px: 2 }}>
        <Typography variant="h2" color="primary" display="flex" alignItems="center" justifyContent="space-between">
            Оформить гостевой пропуск
            <img src={car} style={{ height: '48px' }} />
        </Typography>
    </AccentPaper>;

    if (data?.length) {

        return <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="h2" sx={{
                "&,&>*": {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }
            }} >
                Пропуска
                <NavLink variant="body2" route={[['page', 'entrypass'], ['id']]}>Все <ChevronRight fontSize="small" /></NavLink>
            </Typography>
            {data?.map(buildEntryPassListItem)}
            {btn}
        </Box>;
    } else {
        return btn;
    }
}

const epCollumns = [
    { name: 'CarNumber', variant: 'h3' },
    { name: 'CarModel', variant: 'caption' },
    { name: 'Color', variant: 'caption', color: 'textSecondary' },
    { name: 'Expire', variant: 'h4' }
].map(n => {
    const col = { ...columns.find(x => x.name == n.name) } as ColumnData<EntryPass>;
    if (col.routerLink) {
        col.routerParams = p => {
            p.push(['page', 'entrypass']);
            return p;
        }
    }
    const renderer = col.renderer || ((x: any, o: EntryPass, th: Theme, ta: BaseDataTable<EntryPass>, d?: Renderer<EntryPass>) => d ? d(x, o, th, ta, d) : x);
    col.renderer = (x, o, th, ta, d) => <Typography variant={n.variant as Variant} color={n.color}>{renderer(x, o, th, ta, d)}</Typography>
    return col;
});


function DesktopWidget() {
    return <Card sx={{ flex: 1 }}>
        <CardHeader
            titleTypographyProps={{ display: 'flex', variant: 'h1' }}
            title={<>
                Выданные пропуска
                <NavLink variant="body2" route={[['page', 'entrypass'], ['id']]}>Все <ChevronRight fontSize="small" /></NavLink>
                <NavButton size="small" sx={{ ml: 'auto' }} route={[['page', 'entrypass'], ['id', 'new']]} variant="contained" color="info">
                    <AddRounded />
                </NavButton>
            </>} />
        <DataTable<EntryPass> typeId="EntryPass"
            columns={epCollumns}
            dataParser={entryPassParse}
            cmd={'EntryPassList'}
            noDataRenderer={() => <NoDataText>Пропуска отсутствуют</NoDataText>}
            showFilter={false}
            onSelectionChange={x => x[0] && route.setState([['page','entrypass'],['id', x[0]]])} />
    </Card>;
}

export function EntryPassWidget() {
    const ism = useIsMobile();
    const tenantId = useTenantId();
    return tenantId > 1 ? ism ? <MobileWidget /> : <DesktopWidget /> : <></>;
}